import { lazyLoad } from "utils/loadable";

export const AdminJobsDetails = lazyLoad(
  () => import("./index"),
  (module) => module.AdminJobsDetails
);
